import { combineReducers } from 'redux';
import { IRootState } from '../../types/redux/root';
import { app } from './app';
import { forms } from './forms';
import { layouts } from './layouts';
import { menu } from './menu';
import { tables } from './tables';
import { kanban } from './kanban';
import { commentaries } from './commentaries';

export default combineReducers<IRootState>({
    app,
    commentaries,
    forms,
    layouts,
    menu,
    tables,
    kanban,
});
